import { NavLink, useLocation } from "react-router-dom";
import { Gamepad2, Image as ImageIcon, Play, Home as HomeIcon } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: HomeIcon, testId: "topnav-home", end: true },
  {
    to: "/discuss",
    label: "Picture Guide",
    icon: ImageIcon,
    testId: "topnav-picture",
    // Highlight through the whole picture-guide flow.
    matchPrefix: ["/discuss", "/select-volunteer", "/v/", "/final-packing", "/team-up", "/done"],
  },
  { to: "/video", label: "Video Guide", icon: Play, testId: "topnav-video" },
];

export default function TopNav() {
  const { pathname } = useLocation();
  return (
    <header
      className="sticky top-0 z-40 bg-white border-b-[3px] border-[var(--border-heavy)]"
      data-testid="top-nav"
    >
      <div className="mx-auto max-w-5xl px-4 py-3 flex items-center justify-between gap-3">
        <NavLink
          to="/"
          className="flex items-center gap-2"
          data-testid="topnav-logo"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-[var(--arcade-ink)] bg-[var(--arcade-yellow)] shadow-[2px_2px_0px_var(--arcade-ink)]">
            <Gamepad2 className="h-4 w-4 text-[var(--arcade-ink)]" strokeWidth={3} />
          </span>
          <span className="hidden sm:inline font-heading text-base font-semibold uppercase tracking-wide whitespace-nowrap">Game Designer Kit</span>
        </NavLink>

        <nav className="flex items-center gap-2">
          {items.map(({ to, label, icon: Icon, testId, end, matchPrefix }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) => {
                const active =
                  isActive ||
                  (matchPrefix &&
                    matchPrefix.some((p) =>
                      p.endsWith("/") ? pathname.startsWith(p) : pathname === p
                    ));
                return `arcade-btn whitespace-nowrap text-[10px] sm:text-xs px-3 py-2 ${
                  active ? "" : "arcade-btn-ghost"
                }`;
              }}
            >
              <Icon strokeWidth={3} className="h-3.5 w-3.5" />
              <span className="hidden sm:inline">{label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
